import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/EmpresaFinanceiroActions';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

const NewState = {
    observacao: null,
    selecteds: null,
};

class EmpresaFinanceiroGrupoDialog extends XAPPComponent {

    state = { ...NewState };

    componentDidUpdate(prevProps) {
        if (this.props.EmpresaFinanceiro.error) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.error,
                variant: 'error'
            });
            this.props.EmpresaFinanceiro.error = null;
        }

        if (prevProps.open === null && this.props.open !== null) {
            this.setState({ ...this.props.open });
        }
        else if (prevProps.open !== null && this.props.open === null) {
            this.setState(NewState);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeSubmitted = () => {
        const { observacao } = this.state;
        return (
            observacao !== null && observacao !== ""
        )
    }

    render() {
        const { savePagarReceber, open, xappRouteParams, openDialog, filter } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                id="FinanceiroGrupo"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                maxWidth="sm"
                fullScreen={md.mobile() !== null}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"Criar grupo"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className="pt-8 flex">
                        <TextField
                            className="m-12"
                            id="observacao"
                            name="observacao"
                            label="Observações"
                            value={form.observacao}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                onClick={(ev) => {
                                    savePagarReceber("CRIARGRUPO", form, xappRouteParams, filter);
                                    openDialog(null);
                                }}
                                //disabled={!this.canBeSubmitted()}
                                variant="contained"
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={'done'}
                                label={md.mobile() === null && md.tablet() === null ? 'CRIAR' : ''}
                                key={"btnCriarGrupo"}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        savePagarReceber: Actions.savePagarReceber,
        showMessage: AppActions.showMessage
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroGrupoDialog)));
